export interface ServerConfig {
  serverUrl: string;
  port: string;
  httpProtocol: string;
  wsProtocol: string;
}

export const fullHttpURL = (c: ServerConfig): string =>
  `${c.httpProtocol}${c.serverUrl}:${c.port}`;

export const fullWSURL = (c: ServerConfig): string =>
  `${c.wsProtocol}${c.serverUrl}:${c.port}`;

export function defineServerConfig(): ServerConfig {
  if (import.meta.env.PROD) {
    const wsProtocol = window.location.protocol.startsWith("https")
      ? "wss://"
      : "ws://";
    return {
      serverUrl: window.location.hostname,
      port: window.location.port,
      httpProtocol: `${window.location.protocol}//`,
      wsProtocol,
    };
  }
  const wsProtocol = window.location.protocol.startsWith("https") ? "wss://" : "ws://";
  return {
    serverUrl: window.location.hostname,
    port: window.location.port,
    httpProtocol: `${window.location.protocol}//`,
    wsProtocol,
  };
}
